var map = {
	"./2c2p.svg": "5a33",
	"./BCA.svg": "9e48",
	"./BRI.svg": "16c9",
	"./BSI.svg": "3a0d",
	"./DOKU.svg": "de5b",
	"./Mandiri.svg": "16f2",
	"./active-icon.svg": "2b86",
	"./adyen.svg": "6ff8",
	"./alipay-logo.svg": "bbd2",
	"./alipay.svg": "e47f",
	"./amex.svg": "485e",
	"./applepay.svg": "5173",
	"./back.svg": "7338",
	"./balance.svg": "75c6",
	"./cash.svg": "c9a3",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./credit-card-active.svg": "7e37",
	"./credit-card.svg": "98dc",
	"./dapp.svg": "ef84",
	"./delete.svg": "0d45",
	"./diners.svg": "b4e1",
	"./discover.svg": "b150",
	"./dot-off.svg": "781c",
	"./dot-on.svg": "1f52",
	"./edit.svg": "daf0",
	"./eftpos_australia.svg": "b7c8",
	"./error-cash-icon.svg": "9982",
	"./error-icon.svg": "427a",
	"./error.svg": "28c3",
	"./exclamation.svg": "177c",
	"./gcash.svg": "ff5b",
	"./hll-logo-cashier.svg": "f7ef",
	"./hll-logo-footer.svg": "7397",
	"./hll-logo.svg": "e5e2",
	"./huawei.svg": "2250d",
	"./inactive-icon.svg": "7f90",
	"./jcb.svg": "03e8",
	"./jdpay.svg": "1717",
	"./jkopay.svg": "995a",
	"./left.svg": "2b80",
	"./line.svg": "aa4c",
	"./maestro.svg": "b3aa",
	"./mastercard.svg": "8302",
	"./meizu.svg": "4611",
	"./mi.svg": "699b",
	"./momo.svg": "ea95",
	"./oppo.svg": "6708",
	"./other-payment-methods-active.svg": "e41f",
	"./other-payment-methods.svg": "8edc",
	"./pay-scan.svg": "f1aa",
	"./payme-hearder-logo.svg": "7e0a",
	"./payme.svg": "ebbf",
	"./paytm.svg": "6d81",
	"./plus.svg": "eb38",
	"./question.svg": "9872",
	"./radio-disabled.svg": "1d77",
	"./radio-off.svg": "1d1f",
	"./radio-on.svg": "34ae",
	"./right-arrow.svg": "c686",
	"./step-icon-1.svg": "0fdb",
	"./step-icon-2.svg": "24a0",
	"./step-icon-3.svg": "1129",
	"./success-cash-icon.svg": "2c14",
	"./success-icon.svg": "13a1",
	"./tag.svg": "81fd",
	"./tng.svg": "c3be",
	"./top-up.svg": "5670",
	"./uatp.svg": "267f",
	"./unionpay.svg": "4996",
	"./unknown.svg": "ba87",
	"./visa.svg": "30e2",
	"./vivo.svg": "1556",
	"./wallet-active.svg": "60de",
	"./wallet.svg": "4f4a",
	"./wechat.svg": "95d6",
	"./wxpay-des.svg": "a689",
	"./wxpay-logo.svg": "4fba",
	"./yunquickpass.svg": "5206",
	"./zh.svg": "5719"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";